import { render } from "./Storage.vue?vue&type=template&id=ca8f6734"
import script from "./Storage.vue?vue&type=script&lang=js"
export * from "./Storage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/villageOverview/Storage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca8f6734"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca8f6734', __exports__)) {
    api.reload('ca8f6734', __exports__)
  }
  
  module.hot.accept("./Storage.vue?vue&type=template&id=ca8f6734", () => {
    api.rerender('ca8f6734', render)
  })

}


export default __exports__